export default __webpack_public_path__ + "static/media/Scholar's Gloves of the Burning Disc.03d8e1d1.jpg";